const state = {
  accessToken: localStorage.getItem('accessToken') || null,
  refreshToken: localStorage.getItem('refreshToken') || null
}

const getters = {
  accessToken: (state) => state.accessToken,
  refreshToken: (state) => state.refreshToken
}

const actions = {
  setAccessToken({ commit }, newAccessToken) {
    if (!!newAccessToken) {
      localStorage.setItem('accessToken', newAccessToken)
    } else {
      localStorage.removeItem('accessToken')
    }

    commit('SET_ACCESS_TOKEN', newAccessToken)
  },
  setRefreshToken({ commit }, newRefreshToken) {
    if (!!newRefreshToken) {
      localStorage.setItem('refreshToken', newRefreshToken)
    } else {
      localStorage.removeItem('refreshToken')
    }

    commit('SET_REFRESH_TOKEN', newRefreshToken)
  }
}

const mutations = {
  SET_ACCESS_TOKEN: (state, newAccessToken) => {
    state.accessToken = newAccessToken
  },
  SET_REFRESH_TOKEN: (state, newRefreshToken) => {
    state.refreshToken = newRefreshToken
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
